import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import TopBar from '../TopBar';
import agent from '../../agent';

const CATEGORY_CHIP = {
  bug: { label: 'Bug', color: 'error' },
  suggestion: { label: 'Suggestion', color: 'primary' },
  general: { label: 'General', color: 'default' },
  track_request: { label: 'Track request', color: 'warning' },
};

const formatDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const AdminFeedbackView = ({ currentUser }) => {
  const navigate = useNavigate();
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isAdmin = currentUser?.userRoles?.some(r => r.role === 'admin');
    if (!isAdmin) {
      navigate('/404');
      return;
    }

    agent.Feedback.getAll()
      .then(res => setFeedbacks(res.feedbacks || []))
      .catch(() => navigate('/404'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <TopBar />
      <Box sx={{ p: 3, maxWidth: 1000, mx: 'auto' }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
          Feedback Dashboard
        </Typography>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
            <CircularProgress />
          </Box>
        ) : feedbacks.length === 0 ? (
          <Typography sx={{ color: 'text.secondary', mt: 4, textAlign: 'center' }}>
            No feedback yet.
          </Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Date</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Username</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Category</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Message</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {feedbacks.map(fb => (
                  <TableRow key={fb.id} hover>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      {formatDate(fb.createdAt)}
                    </TableCell>
                    <TableCell>{fb.username}</TableCell>
                    <TableCell>
                      <Chip
                        label={CATEGORY_CHIP[fb.category]?.label ?? fb.category}
                        color={CATEGORY_CHIP[fb.category]?.color ?? 'default'}
                        size="small"
                      />
                    </TableCell>
                    <TableCell sx={{ maxWidth: 400, wordBreak: 'break-word' }}>
                      {fb.message}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </div>
  );
};

const mapStateToProps = state => ({
  currentUser: state.common.currentUser,
});

export default connect(mapStateToProps)(AdminFeedbackView);
